/**
 * La testata del banco: dove sei, e cosa sta succedendo adesso.
 *
 * Sta qui perché era riscritta a mano in sei schermate — sei copie di
 * `<header className="testata">` con dentro le stesse due classi, che è il
 * genere di ripetizione che si nota solo quando una delle sei ha già smesso di
 * somigliare alle altre.
 *
 * **A composizione e non ad array.** `ricezione.tsx` intercala i bottoni fra le
 * coppie — `Stacca` e `Annulla arrivo` stanno in mezzo, non in fondo — e ha due
 * gruppi che compaiono solo a volte. Con `voci={[...]}` la schermata più
 * toccata del banco sarebbe stata l'unica a non poterlo usare, e un componente
 * che la schermata principale non usa non è la regola: è un'altra eccezione.
 *
 * Le misure e il troncamento restano in `stile.css`, dove sono motivati:
 * `flex-wrap: nowrap` perché se la testata va a capo la sua riga scende e non
 * coincide più con quella del menu.
 */

import type { ReactNode } from 'react';

/** Una coppia: cosa stiamo guardando, e quanto ne è. */
export function Voce({ k, v }: { readonly k: string; readonly v: ReactNode }) {
  return (
    <>
      <span className="testata__k">{k}</span>
      <span className="testata__v">{v}</span>
    </>
  );
}

/** Quello che spinge il resto a destra. Uno per testata. */
export function Spazio() {
  return <span className="testata__grow" />;
}

export function Testata({ children }: { readonly children: ReactNode }) {
  return <header className="testata">{children}</header>;
}
